import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({

  selector: 'custom-filter',

  templateUrl: './custom-filter.component.html',

  styleUrls: ['./custom-filter.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ]),

    trigger('slideInOut', [

      state('open', style({

        height: '*',

        overflow: 'hidden',

        opacity: '1',

        margin: '10px 0'

      })),

      state('closed', style({

        height: '0',

        overflow: 'hidden',

        opacity: '0',

      })),

      transition('open <=> closed', [

        animate('0.3s ease-in-out')

      ])

    ])

  ]

})

export class CustomFilterComponent implements OnInit {

  lst_Filtered: any = []; //? لیست کمکی برای نگهداری موقت لیست فیلتر شده

  bShowList: boolean = true; //? جهت نمایش لیست فیلتر شده

  bFirstLoad: boolean = true;

  @Input() isDisabled: boolean = false; //? غیرفعال بودن تکست باکس - اختیاری

  @Input() stylesArray!: any[]; //? تکست باکس - اختیاری 'style' 

  @Input() str_Placeholder!: string; //? تکست باکس - اختیاری 'placeholder' 

  @Input() strValue!: string; //? مقدار اولیه تکست باکس - اختیاری

  @Input() strComment!: any[]; //? متغیری که نام نمایشی آیتم هارا را مشخص می کند

  @Input() lst_Main!: any[]; //? لیست اصلی

  @Input() lst_SearchKey!: any[]; //? متغیر هایی که بر اساس انها می خواهیم فیلتر انجام دهیم

  @Output() hideOptions = new EventEmitter(); //? بستن فرم بعد از کلیک بر روی آیتم

  mdl_Filter: FormGroup = this.formBuilder.group({

    strText: new FormControl(''),

  })

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {

    if (!this.lst_Main) {

      throw new Error('lst_Main is required.');

    }

    if (!this.lst_SearchKey) {

      throw new Error('lst_SearchKey is required.');

    }

    if (this.strValue && this.strValue != '') {

      this.mdl_Filter.controls['strText'].setValue(this.strValue)

    }

    if (this.isDisabled) {

      this.mdl_Filter.controls['strText'].disable()

    }

  }

  onFilter() {

    // اگر کاربر چیزی را وارد نکرده بود

    if (this.mdl_Filter.get('strText')?.value.trim() == '') {

      this.lst_Filtered = this.lst_Main;

      this.hideOptions.emit({})

    }

    // اگر کاربر متنی را وارد کرده بود  

    else {

      this.lst_Filtered = this.lst_Main.filter((item: any) => {

        return this.lst_SearchKey.some((key) => {

          if (key in item) {

            return item[key]?.toString().includes(this.mdl_Filter.get('strText')?.value || '');

          }

          return false;

        });

      });

    }

  }

  onFocus() {

    // نمایش آیکون لیست برای اولین بار

    if (this.bFirstLoad) {

      this.bFirstLoad = false;

    }


    this.lst_Filtered = this.lst_Main;

    // نشان دادن لیست فیلتر شده

    this.bShowList = true;

  }

  onBlur() {

    // const filter_Body = document.querySelector('.filter-container') as HTMLElement;

    // document.addEventListener('click', (event: any) => {

    //   if (!filter_Body.contains(event.target)) {

    //     this.bShowList = false;

    //     this.lst_Filtered = [];

    //   }

    // });

  }

  hide_List() {

    this.bShowList = false;

    this.lst_Filtered = [];

  }

  onClicked_Value(item: any) {

    this.mdl_Filter.controls['strText'].setValue(item[this.strComment as unknown as keyof typeof item]);

    this.hideOptions.emit(item);

    this.bShowList = false;

    this.lst_Filtered = [];

  }

  getStylesObject(): { [key: string]: string } {

    if (!this.stylesArray) return {};

    let styles: { [key: string]: string } = {};

    this.stylesArray.forEach(styleString => {

      const [property, value] = styleString.split(':').map((s: any) => s.trim());

      styles[property] = value;

    });

    return styles;

  }


}
